import React from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Button, Modal, Dropdown } from "react-bootstrap";
import {
  getContactsActions,
  deleteContactAction,
  editSetAsDefaultContactAction,
  getUserRolesAction,
  reActivateDeletedContactAction,
  addContactActionWithPagination,
  GetCountofInProgressTransactions,
  getUserRolesActionNew,
  resendRegisterContactLinkAction,
  editContactDsdDataAction,
  checkArtistDuplicatePublicUrlAction,
  myProfileAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import AddContact from "./CreateContactNew";
import EditContact from "./EditContactNew";
import noRecord from "./../../assets/img/no-record.png";
import NoContact from "./../../assets/img/no-contact.jpg";
import PhoneNumber from "../Common/phoneNumber";
import DataTable from "react-data-table-component";
import Logo from "./../../assets/img/logo.png";
import {
  checkObjExists,
  toastMessage,
  tranformStrToVar,
  currencyFormat,
} from "../Common/Common";
import * as code from "../../config/Constants";
import { TextField, IconButton } from "@material-ui/core";
import {
  CheckCircle,
  CheckCircleOutline,
  Restore,
  Delete,
  Edit,
  Search,
  Visibility,
} from "@material-ui/icons";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { InputAdornment } from "@material-ui/core";
import ReactPaginate from "react-paginate";
import { DebounceInput } from "react-debounce-input";
import { color } from "highcharts";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { getBillingPaymentDetails } from "../../actions/BillingActions";
import { cryptoTokenDecode } from "../Common/Common";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../config/Constants";
import * as message from "./../../config/CommonMessages";
import moment from "moment";
import {
  ContentPasteGo,
  UploadFile,
  AppRegistration,
} from "@mui/icons-material";
import Tooltip from "@material-ui/core/Tooltip";
import ViewContact from "./ViewContact";
import Detail from "./Detail/Detail";
import { ErrorMessage, Field, Form, Formik } from "formik";
import CKEditor from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-classic";
import UrlConstants from "./../../config/UrlConstants";
import * as Yup from "yup";
import $ from "jquery";
var CryptoJS = require("crypto-js");

const config = {
  fontColor: {
    colors: [
      {
        color: "hsl(0, 0%, 0%)",
        label: "Black",
      },
      {
        color: "hsl(0, 0%, 30%)",
        label: "Dim grey",
      },
      {
        color: "hsl(0, 0%, 60%)",
        label: "Grey",
      },
      {
        color: "hsl(0, 0%, 90%)",
        label: "Light grey",
      },
      {
        color: "hsl(0, 0%, 100%)",
        label: "White",
        hasBorder: true,
      },
    ],
  },
  fontBackgroundColor: {
    colors: [
      {
        color: "hsl(0, 75%, 60%)",
        label: "Red",
      },
      {
        color: "hsl(30, 75%, 60%)",
        label: "Orange",
      },
      {
        color: "hsl(60, 75%, 60%)",
        label: "Yellow",
      },
      {
        color: "hsl(90, 75%, 60%)",
        label: "Light green",
      },
      {
        color: "hsl(120, 75%, 60%)",
        label: "Green",
      },
    ],
  },
  toolbar: [
    "bold",
    "strike",
    "italic",
    "link",
    "bulletedList",
    "numberedList",
    "blockQuote",
    "fontColor",
    "fontBackgroundColor",
  ],
  heading: {
    options: [
      { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
      {
        model: "heading1",
        view: "h1",
        title: "Heading 1",
        class: "ck-heading_heading1",
      },
      {
        model: "heading2",
        view: "h2",
        title: "Heading 2",
        class: "ck-heading_heading2",
      },
    ],
  },
};

const ContactsFilter = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search by name"
      value={filterText}
      onChange={onFilter}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      variant="standard"
    />
    <Button
      type="button"
      onClick={onClear}
      variant="primary"
      className="btn-blue btn-head ml-2"
    >
      Clear
    </Button>
  </>
);

const columns = [
  {
    name: "Name",
    selector: "firstname",
    sortable: true,
    ignoreRowClick: true,
    width: window.innerWidth <= 1366 ? "200px" : "",
  },
  {
    name: "Role",
    selector: "role",
    //sortable: true,
  },
  {
    name: "Mobile Number",
    selector: "mobileNumber",
    //sortable: true,
    width: window.innerWidth <= 1366 ? "200px" : "",
  },
  {
    name: "Email",
    selector: "email",
    sortable: true,
    width: window.innerWidth <= 1366 ? "270px" : "",
  },
  {
    name: "Color",
    selector: "color",
    //sortable: true,
    width: "5%",
  },
  {
    name: "Status",
    selector: "isDeletedVendor",
    //sortable: true,
    width: "5%",
  },
  {
    name: "",
    selector: "view",
    right: true,
    ignoreRowClick: true,
    width: "5%",
  },
  {
    name: "",
    selector: "edit",
    right: true,
    ignoreRowClick: true,
    width: "5%",
  },
  {
    name: "",
    selector: "editOther",
    right: true,
    ignoreRowClick: true,
    width: "5%",
  },
  {
    name: "",
    selector: "delete",
    right: true,
    ignoreRowClick: true,
    width: "5%",
  },
  {
    name: "",
    selector: "uploadDoc",
    right: true,
    ignoreRowClick: true,
    width: "5%",
  },
  {
    name: "",
    selector: "resendRegisterLink",
    right: true,
    ignoreRowClick: true,
    width: "5%",
  },
];

const initialDsdValues = {
  roles: [],
  ownerId: "",
  userId: "",
  contactId: "",
  bio: "",
  availability: "",
  includeUSHolidays: false,
  includeWeekend: false,
  defaultDuration: "30",
  publicUrl: "",
  defaultBookingAmount: "0",
};

function Contacts({
  getContactsActions,
  getUserRolesAction,
  deleteContactAction,
  reActivateDeletedContactAction,
  addContactActionWithPagination,
  GetCountofInProgressTransactions,
  getUserRolesActionNew,
  getBillingPaymentDetails,
  resendRegisterContactLinkAction,
  editContactDsdDataAction,
  checkArtistDuplicatePublicUrlAction,
  myProfileAction,
}) {
  const history = useHistory();
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );
  const [contacts, setContacts] = React.useState([]);
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [showEditDsdModal, setShowEditDsdModal] = React.useState(false);
  const [showViewModal, setShowViewModal] = React.useState(false);
  const [showUploadDoc, setShowUploadDoc] = React.useState(false);
  const [contactData, setContactData] = React.useState({});
  const [showLoader, setShowLoader] = React.useState(false);
  const [numberOfPages, setnumberOfPages] = React.useState();
  const [PageNumber, setPageNumber] = React.useState(0);
  const [Rerander, setRerander] = React.useState(0);
  const [RollId, setRollId] = React.useState();
  const [PageSize, SetPageSize] = React.useState(10);
  const [userRoles, setUserRoles] = React.useState([]);
  const [selectedRole, setSelectedRole] = React.useState("");
  const [usertype, setUsertype] = React.useState(cryptoTokenDecode().usertype);
  const [permissionarray, setPermissionarray] = React.useState([]);
  const [dsdInfo, setDsdInfo] = React.useState(initialDsdValues);
  const [ownerId] = React.useState(
    cryptoTokenDecode().usertype === message.ACCTOWNER
      ? localStorage.getItem("ID")
      : localStorage.getItem("ownerId")
  );
  const [companyName, setCompanyName] = React.useState("");
  const [amountFocus, setAmountFocus] = React.useState(false);
  const [duplicatePublicUrlErr, setDuplicatePublicUrlErr] = React.useState(
    false
  );
  const [defaultBookingAmtErr, setDefaultBookingAmtErr] = React.useState(false);

  React.useEffect(() => {
    setShowLoader(true);
    // getAllContacts();
    getUserRolesActionNew().then((roleList) => {
      let roleObj = roleList.find((o) => o.name === "Artist");
      let roleIdVar = roleObj._id;
      setSelectedRole(roleIdVar);
      getContactsWithPagination(roleIdVar);
    });

    // this api calls only for account owner , because account owner has payment details only.
    if (localStorage.getItem("usertype") === "ACCTOWNER") {
      // getPaymentDetails();
      getAccOwnerDetails();
    }

    getUserPermissions();
  }, [PageNumber, Rerander]);

  React.useEffect(() => {
    if (amountFocus) {
      $(".amount-input").focus();
    }
  }, [amountFocus]);

  const getAccOwnerDetails = async () => {
    // console.log("getAccOwnerDetails");
    try {
      // console.log("getAccOwnerDetails try");
      await myProfileAction()
        .then((res) => {
          // console.log("getAccOwnerDetails myProfileAction");

          if (res && res.status === code.OK) {
            let roleObj =
              (res.data &&
                res.data.dsd &&
                res.data.dsd.roles &&
                res.data.dsd.roles.length > 0 &&
                res.data.dsd.roles.find((o) => o.roleId === "ACCOWNER")) ||
              {};

            if (roleObj && roleObj !== undefined && checkObjExists(roleObj)) {
              let compName =
                (roleObj.companyInformation &&
                  checkObjExists(roleObj.companyInformation) &&
                  roleObj.companyInformation.name) ||
                "";
              setCompanyName(compName);
            }
          }
        })
        .catch((err) => {
          // console.log("my info catch err 11111", err);
          console.log(err);
        });
    } catch (err) {
      // console.log("my info catch err 2222", err);
      console.log(err);
      return err;
    }
  };

  function getUserPermissions() {
    // console.log("getUserPermissions usertype", cryptoTokenDecode().usertype);
    if (usertype === message.VENDOR) {
      let permission = localStorage.getItem("otherInfo");
      let permissionarray;
      if (permission) {
        let bytes = CryptoJS.AES.decrypt(
          permission,
          REACT_APP_CRYPTO_SECRET_KEY
        );
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        // console.log("getUserPermissions decryptedData39", decryptedData);
        permissionarray = decryptedData.split(",");
        // console.log("getUserPermissions permissionarray", permissionarray);
        setPermissionarray(permissionarray);
      }
    }
  }

  function checkPermission(checkFor) {
    if (usertype === message.ACCTOWNER) {
      return true;
    } else {
      const hasSome =
        permissionarray &&
        permissionarray.length > 0 &&
        checkFor.some((item) => permissionarray.includes(item));
      return hasSome;
    }
  }

  //this function is called for updation of invoice calculations , so when we add any contact it updates calculations.
  function getPaymentDetails() {
    const today = moment();
    let data = {
      userId: localStorage.getItem("ID"),
      invoicePeriod: today.format("YYYYMM"),
    };
    getBillingPaymentDetails(data)
      .then((res) => {})
      .catch((err) => {
        // console.log(err);
      });
  }

  function getAllContacts() {
    getContactsActions("Artist")
      .then((contactRes) => {
        getUserRolesAction();
        setContacts(contactRes.data);
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
      });

    return contacts;
  }

  const handlePageClick = (event) => {
    setPageNumber(event.selected);
  };

  const handleChange = (event) => {
    SetPageSize(event.target.value);
    setRerander(!Rerander);
  };

  function getContactsWithPagination(roleIdVar) {
    // console.log("selectedRole", selectedRole);
    let formData = {
      page: PageNumber,
      searching: filterText,
      WantDeletedalso: true,
      SearchWithEmailAlso: true,
      PageSize: PageSize,
      roleFilter: roleIdVar,
      ownerID: localStorage.getItem("ownerId"),
    };
    addContactActionWithPagination(formData)
      .then((res) => {
        // console.log("addContactActionWithPagination res", res);
        // getUserRolesAction();
        if (res.status == 200) {
          setShowLoader(false);
          setContacts(res.data.data);
          setnumberOfPages(res.data.total);
          //setRollId(res.data.data[0].roles[0]);
          if (res.data && res.data.data.length > 0) {
            setRollId(res.data.data[0].roles[0]);
          }
        } else {
          setShowLoader(false);
          setContacts([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    return contacts;
  }

  const Dosearch = (SearchValue) => {
    // console.log("searchValue",SearchValue)
    setFilterText(SearchValue);
    setRerander(!Rerander);
  };

  const handleClear = () => {
    if (filterText) {
      setFilterText("");
      setRerander(!Rerander);
    }
  };

  function checkTransaction(id) {
    setShowLoader(true);
    // console.log("at delete client at New",id)
    GetCountofInProgressTransactions(id, "Artist")
      .then((res) => {
        if (res.status == 200) {
          setShowLoader(false);
          if (res.data.total > 0) {
            confirmAlert({
              // title: 'Delete Artist',
              // message: 'This Artist has InProgress Artworks. Do you want to delete this Artist?',
              // buttons: [
              //   {
              //     label: 'Yes Delete it !',
              //     onClick: () => deleteContact(id)
              //   },
              //   {
              //     label: 'No',
              //     onClick: () => {}
              //   }
              // ]
              customUI: ({ onClose }) => {
                return (
                  <div
                    className="
							 "
                  >
                    <div className="react-confirm-alert-body">
                      <h2>Deactivate Artist</h2>
                      <p>This Artist has InProgress Artworks. </p>
                      <p>Do you want to deactivate this Artist? </p>
                      <div className="react-confirm-alert-button-group">
                        <button
                          onClick={() => {
                            deleteContact(id);
                            onClose();
                          }}
                        >
                          {" "}
                          Yes, deactivate it!{" "}
                        </button>
                        <button onClick={onClose}>No</button>
                      </div>
                    </div>
                  </div>
                );
              },
            });
          } else {
            deleteContact(id);
          }
        } else {
          toastMessage(code.ERROR);
          setShowLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function deleteContact(id) {
    setShowLoader(true);
    deleteContactAction(id)
      .then((res) => {
        // getAllContacts();
        setRerander(!Rerander);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function showAddContactModal() {
    setShowAddModal(true);
  }

  function closeAddModal() {
    setShowAddModal(false);
    // getAllContacts();
    if (filterText) {
      setFilterText("");
      setRerander(!Rerander);
    } else {
      setRerander(!Rerander);
    }
  }

  function editContact(contact) {
    setShowEditModal(true);
    contact.roles = "Artist";

    // console.log("contact 305", contact);
    setContactData(contact);
  }

  function closeEditModal() {
    setShowEditModal(false);
    // getAllContacts();
    setRerander(!Rerander);
  }

  function viewContact(contact) {
    setContactData(contact);
    setShowViewModal(true);
  }

  function closeViewModal() {
    setShowViewModal(false);
    setShowUploadDoc(false);
    // setRerander(!Rerander);
  }

  function contactUploadDoc(contact) {
    setContactData(contact);
    setShowUploadDoc(true);
  }

  function reActivateUser(userId) {
    setShowLoader(true);
    reActivateDeletedContactAction(userId)
      .then((response) => {
        // getAllContacts();
        setRerander(!Rerander);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function resendRegisterContactLink(contact) {
    let data = {
      id: contact.contactId,
    };
    setShowLoader(true);
    resendRegisterContactLinkAction(data)
      .then((res) => {
        setShowLoader(false);
        if (res.status === code.OK) {
          toastMessage(code.SUCCESS, res.data);
        } else {
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const setDsdDetails = (contact) => {
    let dsd =
      (contact &&
        contact.UserData &&
        contact.UserData.length > 0 &&
        contact.UserData[0] &&
        contact.UserData[0].dsd) ||
      {};
    let userId =
      (contact &&
        contact.UserData &&
        contact.UserData.length > 0 &&
        contact.UserData[0] &&
        contact.UserData[0]._id) ||
      "";
    let fname =
      (contact &&
        contact.UserData &&
        contact.UserData.length > 0 &&
        contact.UserData[0] &&
        contact.UserData[0].firstname) ||
      "";

    let compName = localStorage.getItem("companyName")
      ? localStorage.getItem("companyName")
      : companyName
      ? companyName
      : "";

    let defultArtistPublicUrl = (compName ? compName + " " : "") + fname;
    let selectedRoleId = (RollId && checkObjExists(RollId) && RollId._id) || "";

    let bio = "";
    let availability = "";
    let includeUSHolidays = false;
    let includeWeekend = false;
    let defaultDuration = "30";
    let publicUrl = tranformStrToVar(defultArtistPublicUrl) || "";
    let defaultBookingAmount = "0";

    if (checkObjExists(dsd)) {
      let selectedRoleDsd =
        dsd.roles &&
        dsd.roles.length > 0 &&
        dsd.roles.find((o) => o.roleId === selectedRoleId);

      //console.log("selectedRoleDsd", selectedRoleDsd);

      if (
        selectedRoleDsd &&
        selectedRoleDsd !== undefined &&
        checkObjExists(selectedRoleDsd)
      ) {
        bio = selectedRoleDsd.bio || "";
      }

      let selectedStudioDsd =
        dsd.studios &&
        dsd.studios.length > 0 &&
        dsd.studios.find((o) => o.ownerId === ownerId);

      //console.log("selectedStudioDsd", selectedStudioDsd);
      if (
        selectedStudioDsd &&
        selectedStudioDsd !== undefined &&
        checkObjExists(selectedStudioDsd)
      ) {
        availability = selectedStudioDsd.availability || "";
        includeUSHolidays = selectedStudioDsd.includeUSHolidays || false;
        includeWeekend = selectedStudioDsd.includeWeekend || false;
        defaultDuration = selectedStudioDsd.defaultDuration || "30";
        publicUrl =
          selectedStudioDsd.publicUrl ||
          tranformStrToVar(defultArtistPublicUrl);
        defaultBookingAmount = selectedStudioDsd.defaultBookingAmount || "0";
      }
    }

    let data = {
      roles: [selectedRoleId],
      ownerId: ownerId,
      userId: userId,
      contactId: contact._id,
      bio: bio,
      availability: availability,
      includeUSHolidays: includeUSHolidays,
      includeWeekend: includeWeekend,
      defaultDuration: defaultDuration,
      publicUrl: publicUrl,
      defaultBookingAmount: defaultBookingAmount,
    };
    setDsdInfo(data);
  };

  function editContactDsdData(contact) {
    // console.log("editContactDsdData contact", contact);
    setDuplicatePublicUrlErr(false);
    setDefaultBookingAmtErr(false);
    setContactData(contact);
    setDsdDetails(contact);
    setShowEditDsdModal(true);
  }

  function closeEditContactDsdModal() {
    setShowEditDsdModal(false);
    // setRerander(!Rerander);
  }

  const checkDuplicatePublicUrl = (setFieldValue, value) => {
    setFieldValue("publicUrl", tranformStrToVar(value));
    if (value && value !== undefined) {
      let data = {
        publicUrl: value,
        ownerId: ownerId,
        userId: dsdInfo && dsdInfo.userId,
        roleId:
          dsdInfo &&
          dsdInfo.roles &&
          dsdInfo.roles.length > 0 &&
          dsdInfo.roles[0],
      };
      checkArtistDuplicatePublicUrlAction(data)
        .then((res) => {
          if (res && res.status !== code.OK) {
            setDuplicatePublicUrlErr(true);
          } else {
            setDuplicatePublicUrlErr(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setDuplicatePublicUrlErr(false);
        });
    } else {
      setDuplicatePublicUrlErr(false);
    }
  };

  const checkDefaultBookingAmount = (setFieldValue, value) => {
    setFieldValue("defaultBookingAmount", value);
    if (value && value !== undefined) {
      if (!value.match("^([0-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$")) {
        setDefaultBookingAmtErr(true);
      } else {
        setDefaultBookingAmtErr(false);
      }
    } else {
      setDefaultBookingAmtErr(false);
    }
  };

  const updateContactDsdData = (values) => {
    let dsdObj = {
      ...dsdInfo,
      bio: values.bio,
      availability: values.availability,
      includeWeekend: values.includeWeekend,
      includeUSHolidays: values.includeUSHolidays,
      defaultDuration: values.defaultDuration,
      publicUrl: values.publicUrl,
      defaultBookingAmount: values.defaultBookingAmount,
    };
    //setDsdInfo(dsdObj);
    // console.log("updateContactDsd dsdObj", dsdObj);
    if (!duplicatePublicUrlErr && !defaultBookingAmtErr) {
      editContactDsdDataAction(dsdObj)
        .then((response) => {
          closeEditContactDsdModal();
          setRerander(!Rerander);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  let rows = [];
  for (var i = 0; i < contacts.length; i++) {
    let contact = contacts[i];

    let contactObject = {
      id: contact._id,
      firstname:
        contact.UserData[0].firstname + " " + contact.UserData[0].lastname,
      role: "Artist",
      mobileNumber: (
        <PhoneNumber phoneNumber={contact.UserData[0].mobileNumber} />
      ),
      email: contact.UserData[0].email.address,
      color: (
        <div
          className={"contact-color-btn"}
          style={{
            height: "20px",
            width: "20px",
            backgroundColor: contact.color,
          }}
        />
      ),
      dsd: contact.UserData[0].dsd,
      isDeletedVendor:
        contact.isDeleted === false ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          <CheckCircleOutline className="check-out" />
        ),
      delete: checkPermission([message.manage_contact]) ? (
        contact.isDeleted === false ? (
          <IconButton
            onClick={() =>
              checkTransaction(contact._id) && !contact.isDeleted === true
            }
          >
            <Tooltip title="Deactivate">
              <Delete />
            </Tooltip>
          </IconButton>
        ) : (
          <IconButton
            onClick={() => reActivateUser(contact._id) && !contact.isDeleted}
          >
            <Tooltip title="Reactivate">
              <Restore />
            </Tooltip>
          </IconButton>
        )
      ) : (
        ""
      ),
      view: checkPermission([message.manage_contact, message.view_contact]) ? (
        contact.isDeleted === false ? (
          <IconButton
            onClick={() => viewContact(contact) && !contact.isDeleted}
          >
            <Tooltip title="View">
              <Visibility />
            </Tooltip>
          </IconButton>
        ) : (
          ""
        )
      ) : (
        ""
      ),
      edit: checkPermission([message.manage_contact]) ? (
        contact.isDeleted === false ? (
          <IconButton
            onClick={() => editContact(contact) && !contact.isDeleted}
          >
            <Tooltip title="Edit">
              <Edit />
            </Tooltip>
          </IconButton>
        ) : (
          ""
        )
      ) : (
        ""
      ),
      editOther: checkPermission([message.manage_contact]) ? (
        contact.isDeleted === false ? (
          <IconButton
            onClick={() => editContactDsdData(contact) && !contact.isDeleted}
          >
            <Tooltip title="Edit Other Details">
              <AppRegistration />
            </Tooltip>
          </IconButton>
        ) : (
          ""
        )
      ) : (
        ""
      ),
      resendRegisterLink: checkPermission([message.manage_contact]) ? (
        //contact should not be deleted, should not be registered, and should have either email/mobile
        !contact.isDeleted &&
        !contact.isPasswordSet &&
        ((contact.UserData[0] &&
          contact.UserData[0].email &&
          contact.UserData[0].email.address) ||
          (contact.UserData[0] && contact.UserData[0].mobileNumber)) ? (
          <IconButton
            onClick={() =>
              resendRegisterContactLink(contact) && !contact.isDeleted
            }
          >
            <Tooltip title="Resend register link">
              <ContentPasteGo />
            </Tooltip>
          </IconButton>
        ) : (
          ""
        )
      ) : (
        ""
      ),
      uploadDoc:
        usertype === message.ACCTOWNER ? (
          contact.isDeleted === false ? (
            <IconButton
              onClick={() => contactUploadDoc(contact) && !contact.isDeleted}
            >
              <Tooltip title="Upload Personal Docs">
                <UploadFile />
              </Tooltip>
            </IconButton>
          ) : (
            ""
          )
        ) : (
          ""
        ),
    };

    // let contactData = {
    //     id: client._id,
    //     firstname: client.UserData[0].firstname + ' '  + client.UserData[0].lastname,
    //     role: "Artist",
    //     mobileNumber: <PhoneNumber phoneNumber={client.UserData[0].mobileNumber} />,
    //     email: client.UserData[0].email.address,
    //     isDeletedVendor: client.isDeleted === false ? <CheckCircle className='check' style={{ color: "green" }}/> : <CheckCircleOutline className='check-out'/>,
    //     delete:  client.isDeleted === false ?
    //       (<IconButton onClick={() => deleteClient(client._id) && !client.isDeleted === true}><Delete/></IconButton>) :
    //       (<IconButton onClick={() => reActivateUser(client._id) && !client.isDeleted}><Restore/></IconButton>),
    //     edit: client.isDeleted === false ? <IconButton onClick={() => editClient(client._id) && !client.isDeleted}><Edit/></IconButton> : ""
    // }

    rows.push(contactObject);
    // console.log("contact data", contactData);
  }
  const filteredContacts = rows.filter(
    (contact) =>
      (contact.role === "Artist" &&
        contact.firstname &&
        contact.firstname.toLowerCase().includes(filterText.toLowerCase())) ||
      (contact.lastname &&
        contact.lastname.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <ContactsFilter
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  });

  return (
    <div>
      {showViewModal || showUploadDoc ? (
        <Detail
          contactData={contactData}
          roleForPopup={"Artist"}
          tab={showViewModal ? "1" : showUploadDoc ? "2" : "1"}
          parentCallback={() => closeViewModal()}
        />
      ) : (
        <div>
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
            <Col xs="4">
              <h4 className="title-med mt-0 pt-1">Artists</h4>
            </Col>
            <Col align="right" className="contact-btn">
              {checkPermission([message.manage_contact]) ? (
                <Button
                  variant="primary"
                  className="btn-blue btn-head"
                  onClick={() => {
                    // if (localStorage.getItem("isActive") === "false") {
                    //   toastMessage(
                    //     code.ERROR,
                    //     "Your subscription is not active, Please activate to continue."
                    //   );
                    // } else {
                    //   showAddContactModal();
                    // }

                    showAddContactModal();
                  }}
                >
                  Add Artist
                </Button>
              ) : (
                ""
              )}
            </Col>
          </Row>

          {showLoader ? (
            <div className="page-loader fixed">
              <div className="page-loader-inner">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          ) : rows.length === 0 ? (
            <>
              <Col className="col-auto" align="right">
                <div className="justify-content-end form-inline">
                  <Row className="trans-listing-head-row">
                    <Col className="col-auto pl-0 d-flex">
                      <Search style={{ marginTop: "7px" }} />
                      <DebounceInput
                        id="search"
                        minLength={0}
                        debounceTimeout={1500}
                        onChange={(e) => Dosearch(e.target.value)}
                        placeholder="Search"
                        value={filterText}
                        autoComplete="off"
                        className="form-control form-control-sm form-control-head"
                      />

                      <Button
                        type="button"
                        onClick={handleClear}
                        variant="primary"
                        className="btn-blue btn-head ml-2"
                        style={{ marginRight: "19px" }}
                      >
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Col>

              <div className="no-transaction">
                <div className="no-transaction-inner">
                  <img src={Logo} className="no-transaction-content" alt="" />
                  <h2 className="no-transaction-content">No artists found</h2>
                  <hr />
                  <Button
                    className="text-uppercase btn-orange btn-orange-lg"
                    onClick={() => {
                      // if (localStorage.getItem("isActive") === "false") {
                      //   toastMessage(
                      //     code.ERROR,
                      //     "Your subscription is not active, Please activate to continue."
                      //   );
                      // } else {
                      //   showAddContactModal();
                      // }
                      showAddContactModal();
                    }}
                  >
                    Add Artist
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <>
              <Col className="col-auto" align="right">
                <div className="justify-content-end form-inline">
                  <Row className="trans-listing-head-row">
                    {/* <Col className="col-auto pl-0 d-flex trans-listing-head-dropdown">
                    </Col> */}
                    <Col className="col-auto pl-0 d-flex">
                      <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
                        <InputLabel id="demo-select-small">Limit</InputLabel>
                        <Select
                          labelId="demo-select-small"
                          id="demo-select-small"
                          value={PageSize}
                          label="Page"
                          onChange={handleChange}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={50}>50</MenuItem>
                          <MenuItem value={100}>100</MenuItem>
                        </Select>
                      </FormControl>
                      <Search style={{ margin: "7px 5px 0px 5px" }} />
                      <DebounceInput
                        id="search"
                        minLength={0}
                        debounceTimeout={1500}
                        onChange={(e) => Dosearch(e.target.value)}
                        placeholder="Search"
                        value={filterText}
                        autoComplete="off"
                        className="form-control form-control-sm form-control-head"
                      />

                      <Button
                        type="button"
                        onClick={handleClear}
                        variant="primary"
                        className="btn-blue btn-head ml-2 mr-2"
                        // style={{ marginRight: "19px" }}
                      >
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Col>
              <DataTable
                title="Artists"
                columns={columns}
                data={rows}
                persistTableHead
              />
            </>
          )}
          {rows.length > 0 && (
            <>
              <div style={{ marginTop: 10 }}>
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </>
          )}

          <Modal
            show={showAddModal}
            onHide={() => closeAddModal()}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med"
            backdrop={false}
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                Add Artist
              </Modal.Title>
            </Modal.Header>
            <AddContact
              onClose={() => closeAddModal()}
              contacts={contacts}
              roleForPopup={"Artist"}
              roleIdForPopup={RollId}
            />
          </Modal>

          <Modal
            show={showEditModal}
            onHide={() => closeEditModal()}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med"
            backdrop={false}
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                Edit Artist
              </Modal.Title>
            </Modal.Header>
            <EditContact
              contactData={contactData}
              contacts={contacts}
              onClose={() => closeEditModal()}
              roleForPopup={"Artist"}
              roleIdForPopup={RollId}
            />
          </Modal>

          <Modal
            show={showEditDsdModal}
            onHide={() => closeEditContactDsdModal()}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med modal-786 modal-tabindex"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                Edit Artist
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="pb-0">
              <Formik
                validateOnBlur={true}
                initialValues={dsdInfo}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({
                  publicUrl: Yup.string()
                    .required(message.ENTER_PUBLIC_URL_POSTFIX)
                    .matches(new RegExp("^[a-z0-9- ]{2,30}$"), {
                      message: message.PUBLIC_URL_POSTFIX_INVALID,
                    }),
                  // .test(
                  //   "publicUrl",
                  //   message.PUBLIC_URL_POSTFIX_EXISTS,
                  //   async (value) => {
                  //     console.log("Validating publicUrl:", value); // Debug log
                  //     if (!value) return true; // Handle undefined value
                  //     const data = {
                  //       publicUrl: value,
                  //       ownerId: this.state.ownerId,
                  //     };
                  //     try {
                  //       const res = await checkArtistDuplicatePublicUrlAction(
                  //         data
                  //       );
                  //       console.log("Duplicate check response:", res); // Debug log
                  //       return res && res.status === code.OK;
                  //     } catch (error) {
                  //       console.error("Error checking duplicate URL:", error); // Debug log
                  //       return true; // Consider valid on error
                  //     }
                  //   }
                  // ),
                  defaultBookingAmount: Yup.string()
                    .required(message.ENTER_AMOUNT)
                    .matches(
                      new RegExp(
                        "^([0-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$"
                      ),
                      {
                        message: message.ENTER_VALID_AMOUNT,
                      }
                    ),
                })}
              >
                {({ errors, touched, values, setFieldValue }) => (
                  <Form className="form-sm form-admin">
                    <Row>
                      <Col xs={12}>
                        <div className="form-group">
                          <label className="control-label">About Artist</label>
                          <CKEditor
                            onInit={(editor) => {
                              editor.ui
                                .getEditableElement()
                                .parentElement.insertBefore(
                                  editor.ui.view.toolbar.element,
                                  editor.ui.getEditableElement()
                                );
                            }}
                            onChange={(event, editor) => {
                              if (editor && editor !== undefined) {
                                setFieldValue("bio", editor.getData());
                              }
                            }}
                            editor={DecoupledEditor}
                            name="bio"
                            data={values.bio}
                            config={config}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={5}>
                        <div className="form-group">
                          <label className="control-label">
                            Public Profile URL
                            <span className="text-danger"> *</span>
                          </label>
                          <label
                            className="control-label"
                            style={{ marginTop: "5px" }}
                          >
                            {UrlConstants.artistPublicProfileUrl}
                          </label>
                        </div>
                      </Col>
                      <Col xs={3}>
                        <div className="form-group">
                          <Field
                            type="text"
                            className="form-control"
                            style={{ marginTop: "26px" }}
                            value={values.publicUrl ? values.publicUrl : ""}
                            name="publicUrl"
                            // handleChange={handleChange}
                            onChange={(e) => {
                              checkDuplicatePublicUrl(
                                setFieldValue,
                                e.target.value
                              );
                              // setFieldValue(
                              //   "publicUrl",
                              //   tranformStrToVar(e.target.value)
                              // );
                            }}
                          />
                          <ErrorMessage
                            name="publicUrl"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                          {duplicatePublicUrlErr && (
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {message.PUBLIC_URL_POSTFIX_EXISTS}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col xs={4}>
                        <div className="form-group">
                          <label
                            className="form-label"
                            htmlFor="defaultBookingAmount"
                          >
                            Default Booking Amount
                            <span className="text-danger"> *</span>
                          </label>

                          {amountFocus ? (
                            <input
                              type="text"
                              name="defaultBookingAmount"
                              className={
                                "form-control text-right amount-input" +
                                (errors.defaultBookingAmount &&
                                touched.defaultBookingAmount
                                  ? " is-invalid"
                                  : "")
                              }
                              value={
                                values.defaultBookingAmount
                                  ? values.defaultBookingAmount
                                  : "0"
                              }
                              onChange={(e) => {
                                checkDefaultBookingAmount(
                                  setFieldValue,
                                  e.target.value
                                );
                                // setFieldValue(
                                //   "defaultBookingAmount",
                                //   e.target.value
                                // );
                              }}
                              onBlur={() => {
                                setAmountFocus(false);
                              }}
                            />
                          ) : (
                            <input
                              type="text"
                              name="defaultBookingAmount"
                              className={
                                "form-control text-right " +
                                (errors.defaultBookingAmount &&
                                touched.defaultBookingAmount
                                  ? " is-invalid"
                                  : "")
                              }
                              onFocus={() => {
                                setAmountFocus(true);
                              }}
                              value={currencyFormat(
                                values.defaultBookingAmount
                              )}
                              defaultValue={
                                values.defaultBookingAmount
                                  ? currencyFormat(values.defaultBookingAmount)
                                  : currencyFormat(0)
                              }
                            />
                          )}
                          <ErrorMessage
                            name="defaultBookingAmount"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          />
                          {defaultBookingAmtErr && (
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {message.ENTER_VALID_AMOUNT}
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <div className="form-group">
                          <label className="control-label">Availability</label>
                          <textarea
                            rows={5}
                            className="form-control"
                            name="availability"
                            value={values.availability}
                            onChange={(e) => {
                              setFieldValue("availability", e.target.value);
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={3}>
                        <div className="form-group">
                          <div className="form-check">
                            <label className="form-check-label">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                name="includeWeekend"
                                checked={values.includeWeekend}
                                onChange={(e) => {
                                  setFieldValue(
                                    "includeWeekend",
                                    e.target.checked
                                  );
                                }}
                              />
                              Include Weekend
                            </label>
                          </div>
                        </div>
                      </Col>
                      <Col xs={3}>
                        <div className="form-group">
                          <div className="form-check">
                            <label className="form-check-label">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                name="includeUSHolidays"
                                checked={values.includeUSHolidays}
                                onChange={(e) => {
                                  setFieldValue(
                                    "includeUSHolidays",
                                    e.target.checked
                                  );
                                }}
                              />
                              Include US Holidays
                            </label>
                          </div>
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="form-group" style={{ display: "flex" }}>
                          <label
                            className="date-label"
                            style={{ paddingRight: "12px" }}
                          >
                            Default Duration
                          </label>
                          <select
                            className="form-control form-control-sm pl-1 date-picker date-duration"
                            style={{ width: "30%", height: "30px" }}
                            value={
                              values.defaultDuration
                                ? values.defaultDuration
                                : 30
                            }
                            onChange={(e) =>
                              setFieldValue("defaultDuration", e.target.value)
                            }
                          >
                            <option value={15}>15 minutes</option>
                            <option value={20}>20 minutes</option>
                            <option value={30}>30 minutes</option>
                            <option value={45}>45 minutes</option>
                            <option value={60}>1 hour</option>
                            <option value={120}>2 hours</option>
                            <option value={180}>3 hours</option>
                            <option value={240}>4 hours</option>
                          </select>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={12}>
                        <>
                          <h6>Suggested example text:</h6>
                          <div style={{ fontSize: "0.8rem" }}>
                            1. **Every Day:** Every day of the week. <br />
                            2. **Regular Hours:** From 8:00 AM to 3:00 PM on
                            most days.
                            <br />
                            3. **Exception on Thursdays:** On Thursdays, starts
                            work later, at 10:00 AM, and is available until 3:00
                            PM. <br />
                            4. **Exception on the Second Tuesday of the Month:**
                            On the second Tuesday of each month, starts work at
                            10:00 AM instead of 8:00 AM, and is available until
                            3:00 PM.
                            <br />
                            5. On Vacations From 10th Sept to 20 Sept.
                          </div>
                        </>
                      </Col>
                    </Row>

                    <div className="modal-footer modal-footer-inner">
                      <Button
                        variant="primary"
                        size="sm"
                        className="btn-blue w-140"
                        onClick={() => {
                          updateContactDsdData(values);
                        }}
                      >
                        Update
                      </Button>
                      <Button
                        variant="outlined"
                        size="sm"
                        className="btn-blue w-140"
                        onClick={() => closeEditContactDsdModal()}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
          </Modal>

          {/* <Modal
        show={showViewModal}
        onHide={() => closeViewModal()}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        className="modal-med modal-786"
        backdrop={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            View Artist
          </Modal.Title>
        </Modal.Header>
        <ViewContact
          contactData={contactData}
          onClose={() => closeViewModal()}
          roleForPopup={"Artist"}
        />
      </Modal> */}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
  };
};

export default connect(
  mapStateToProps,
  {
    getContactsActions,
    deleteContactAction,
    editSetAsDefaultContactAction,
    getUserRolesAction,
    reActivateDeletedContactAction,
    addContactActionWithPagination,
    GetCountofInProgressTransactions,
    getUserRolesActionNew,
    getBillingPaymentDetails,
    resendRegisterContactLinkAction,
    editContactDsdDataAction,
    checkArtistDuplicatePublicUrlAction,
    myProfileAction,
  }
)(Contacts);
